const styles = {
  header: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    m: '0 auto'
  },
  content: {
    my: 2
  },
  modal: {
    position: 'absolute',
    mx: 1,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius: 1,
    boxShadow: 24,
    p: 2,
    '& p': {
      my: 1
    },
    '& button': {
      m: 1
    },
    '@media screen and (max-width: 600px)': {
      p: 2,
      minWidth: '22rem'
    }
  },
  buttonContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 1
  },
  button: {
    margin: '0 !important',
    width: '6rem'
  }
};

export default styles;
